import { __awaiter } from "tslib";
import { useApolloClient } from '@apollo/client';
import { useApiKeys } from '@merchant-portal/credentials';
import { selectors as experimentationSelectors } from '@merchant-portal/experimentation';
import { useSelector } from 'react-redux';
import { propertiesToMap } from '../utils';
import { CREATE_API_CREDENTIALS } from './qqlQueries';
const BOOST_API_KEYS_ENABLED_EXPERIMENT_KEY = 'merchant-portal.boost.gkd-api-keys.enabled';
export const useCreateApiKeyWithToggle = ({ selectedMid }) => {
    if (!selectedMid) {
        throw new Error('SelectedMid is required to create an API key.');
    }
    const isGKDApiKeysEnabled = useSelector(experimentationSelectors.isFeatureToggleEnabled(BOOST_API_KEYS_ENABLED_EXPERIMENT_KEY));
    const apolloClient = useApolloClient();
    const { createApiKey } = useApiKeys({ mid: selectedMid, fetchingApiKeysInitially: false });
    return isGKDApiKeysEnabled
        ? () => __awaiter(void 0, void 0, void 0, function* () {
            const { credentialId, secret } = yield createApiKey();
            return { username: credentialId, password: secret };
        })
        : () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            const { data } = yield apolloClient.mutate({
                mutation: CREATE_API_CREDENTIALS,
                variables: { merchantId: selectedMid }
            });
            const { username, password } = propertiesToMap((_a = data === null || data === void 0 ? void 0 : data.createMerchantApiCredentials) === null || _a === void 0 ? void 0 : _a.properties);
            return { username, password };
        });
};
